import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
const { getACode } = genericActions;
const { getWiFiBatchReports, resetMessage } = reportActions;

const WIFIBatchDetails = ({ selectedBatchId, onBack }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { aCodeList } = useSelector(state => state.generic);
    const [searchItem, setSearchItem] = useState("");
    const today = new Date();
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const { wifiBatchReports, wifiBatchReportsLoading, } = useSelector((state) => state.reports)
    const { defaultCurrency } = useSelector((state) => state.auth);

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            batchID: "",
            isBatchDetail: true,
        },
    });

    useEffect(() => {
        if (selectedBatchId) {
            dispatch(getWiFiBatchReports({
                batchID: selectedBatchId,
                isBatchDetail: true,
            }));
        }
    }, [selectedBatchId]);


    const columns = [
        { displayName: "Batch Id", key: "BatchId" },
        { displayName: "Transaction Id", key: "TransactionId" },
        { displayName: "Serial Number", key: "SerialNumber" },
        { displayName: "Mobile Number", key: "MobileNumber" },
        { displayName: "Street1", key: "Street1" },
        { displayName: "Street2", key: "Street2" },
        { displayName: "City", key: "City" },
        { displayName: "State", key: "State" },
        { displayName: "Zip", key: "Zip" },
        { displayName: "Status", key: "Status" },
        { displayName: "CreatedOn", key: "CreatedOn" },
         { displayName: "UpdatedOn", key: "UpdatedOn" },
        { displayName: "Remarks", key: "Remarks" },

    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(wifiBatchReports) && wifiBatchReports.length > 0
            ? wifiBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [wifiBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            "BatchId": item["BatchID"],
            "TransactionId": item["TransactionID"],
            "SerialNumber": item["SerialNumber"],
            "MobileNumber": item["MobileNumber"],
            "Street1": item["Street1"],
            "Street2": item["Street2"],
            "City": item["City"],
            "State": item["State"],
            "Zip": item["Zip"],
            "Status": item["Status"],
            "CreatedOn": item["CreatedOn"],
             "UpdatedOn": item["UpdatedOn"],
            "Remarks": item["Remarks"],

        }));
    }, [filteredItems]);

    const handleBack = () => {
        onBack();
    }

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            // "Type": item?.TxnType == 26 ? 'eSIM' : 'pSIM',
            "BatchId": item["BatchID"],
            "TransactionId": item["TransactionID"],
            "SerialNumber": item["SerialNumber"],
            "MobileNumber": item["MobileNumber"],
            "Street1": item["Street1"],
            "Street2": item["Street2"],
            "City": item["City"],
            "State": item["State"],
            "Zip": item["Zip"],
            "Status": item["Status"],
            "CreatedOn": item["CreatedOn"],
             "UpdatedOn": item["UpdatedOn"],
            "Remarks": item["Remarks"],
        }));

        downloadExcelSampleFile(data, "WIFI-batch-detail.xlsx");
    };

    return (
        <CardLayout
            title={<> Wi-Fi Batch Details<span style={{ color: "#4b9b60" }}> :#{selectedBatchId}
            </span>
            </>
            }
            icon="ri-file-chart-line "
            rightContent={
                <div className="d-flex gap-2">
                    <Button
                        title="Back"
                        buttonType="button"
                        icon={<i className="ri-arrow-left-line me-1" />}
                        variant="primary"
                        style={{
                            padding: "5px 10px",
                        }}
                        onClick={() => handleBack()}
                    />
                    <Button
                        title="Excel"
                        buttonType="button"
                        variant="secondary"
                        onClick={handleExportExcel}
                        icon={<i className="ri-download-cloud-line me-2" />}
                    />
                </div>
            }
        >
            {/* Table */}
            <div className="mt-2">
                <Table
                    columns={columns}
                    data={rowData}
                    pagination
                    loading={wifiBatchReportsLoading}
                    tableHeight="270px"
                />
            </div>


        </CardLayout>

    );
};

export default WIFIBatchDetails;

